/**
 * Negotiation escalation rules (mirrors backend CaseNegotiation::negotiationEscalationEligibleForCase).
 */

function parseAmount(value) {
    if (value == null || value === '') {
        return null
    }
    const n = Number(String(value).replace(/,/g, ''))
    return Number.isFinite(n) ? n : null
}

export function resolvePrimaryUmInsuranceForNegotiation(activeCase) {
    if (!activeCase?.mp_pip_um?.length) {
        return null
    }
    const list = activeCase.mp_pip_um
    const strictPrimary = list.find(
        (item) =>
            Number(item?.active) === 1 &&
            Number(item?.is_um_primary_insurance) === 1 &&
            Number(item?.has_um) === 1
    )
    return strictPrimary || list.find((item) => item?.is_um_primary_insurance) || list[0]
}

export function isUmNegotiationSplit(activeCase) {
    return Number(resolvePrimaryUmInsuranceForNegotiation(activeCase)?.um_neg_split) === 1
}

/**
 * @returns {boolean}
 */
export function isNegotiationEscalationEligible(activeCase) {
    if (!activeCase) {
        return false
    }
    if (activeCase.practices === undefined || activeCase.attorneys === undefined) {
        return false
    }

    const attorneys = activeCase.attorneys || []
    const hasAttorney = attorneys.some((a) => Number(a?.active) === 1)
    if (!hasAttorney) {
        return false
    }

    const neg = activeCase.case_negotiation
    const owedRaw = neg?.medpay_previous_care_amount_owed
    if (owedRaw === null || owedRaw === undefined || String(owedRaw).trim() === '') {
        return false
    }
    const owedNum = parseAmount(owedRaw)
    if (owedNum === null || owedNum < 0) {
        return false
    }

    const settlementNum = parseAmount(neg?.total_settlement)
    if (settlementNum === null || settlementNum <= 0) {
        return false
    }

    const practices = activeCase.practices || []
    const liaSum = practices.reduce(
        (acc, p) => acc + (parseAmount(p?.lia_neg_offered_amount) || 0),
        0
    )
    const umSplit = isUmNegotiationSplit(activeCase)
    const umSum = practices.reduce((acc, p) => acc + (parseAmount(p?.um_neg_offered_amount) || 0), 0)
    const offeredTotal = liaSum + (umSplit ? umSum : 0)

    return offeredTotal > 0
}
